<template>
  <div class="video-block section-padding">
    <div class="row">
      <div class="col-md-12">
        <div class="main-title">
          <VideoSort />
          <h6>
            {{ $t('JSON.featured-videos') }}
            <!-- {{ searchCount }} -->
          </h6>
        </div>
      </div>
      <TableServer type="featuredVideos" />
    </div>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
  components: {
    VideoSort: () => import('@/components/video/VideoSort'),
  },

  data() {
    return {
      videos: [],
    };
  },

  computed: {
    ...sync([
      'filter.searchCount', //
    ]),
  },
};
</script>
